var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceReserved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4Z",
    fill: "#EFE8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4Z",
    stroke: "#CCB1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22C10.79 22 9 23.79 9 26C9 28.21 10.79 30 13 30C15.21 30 17 28.21 17 26C17 23.79 15.21 22 13 22ZM14 25.68C14 26.29 13.67 26.87 13.15 27.18L12.39 27.64C12.27 27.72 12.13 27.75 12 27.75C11.75 27.75 11.5 27.62 11.36 27.39C11.15 27.04 11.26 26.57 11.62 26.36L12.38 25.9C12.45 25.86 12.5 25.77 12.5 25.69V24.76C12.5 24.34 12.84 24 13.25 24C13.66 24 14 24.34 14 24.75V25.68Z",
    fill: "#9F55FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12H15C12 12 10 13.5 10 17V20.56C10 20.93 10.38 21.16 10.71 21.01C11.69 20.56 12.82 20.39 14.01 20.6C16.64 21.07 18.57 23.51 18.5 26.18C18.49 26.6 18.43 27.01 18.32 27.41C18.24 27.72 18.49 28.01 18.81 28.01H25C28 28.01 30 26.51 30 23.01V17C30 13.5 28 12 25 12ZM20 22.5C18.62 22.5 17.5 21.38 17.5 20C17.5 18.62 18.62 17.5 20 17.5C21.38 17.5 22.5 18.62 22.5 20C22.5 21.38 21.38 22.5 20 22.5ZM27.25 22C27.25 22.41 26.91 22.75 26.5 22.75C26.09 22.75 25.75 22.41 25.75 22V18C25.75 17.59 26.09 17.25 26.5 17.25C26.91 17.25 27.25 17.59 27.25 18V22Z",
    fill: "#9F55FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceReserved);
export default __webpack_public_path__ + "static/media/balance_reserved.f0fc93b832e3870cbf56aae460bbc8f0.svg";
export { ForwardRef as ReactComponent };